export default __webpack_public_path__ + "static/header-logo-26b922ef5c7cfe80b7b01b82dd223f11.webp";